import { Directive, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from '../shared/auth.service';

@Directive({
    selector: '[isAdministratorOrPowerEngineer]',
    standalone: false
})
export class IsAdministratorOrPowerEngineerDirective implements OnInit {
  constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef, private authService: AuthService) {}

  public ngOnInit(): void {
    if (this.authService.isAdministrator() || this.authService.isPowerEngineer()) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
